import React from "react"
import { useTranslation } from "react-i18next"
import { Header, Footer, CookieBanner } from "@bw/layouts"
import { useUser } from "contexts/user"
import { getProfile } from "services/authentication"
import useGlobalTheme from "../../../hooks/useGlobalTheme"
import { Popup } from "../../partials/popup/Popup.jsx"
import { PasswordProtection } from "../../partials/passwordProtection/PasswordProtection"
import { toast } from "react-toastify"
import * as Yup from "yup"

const Layout = ({ headerNegative, children, pageContext, location }) => {
  const { t } = useTranslation()
  const theme = useGlobalTheme()
  const [user, dispatch] = useUser()
  const [isProtected, setIsProtected] = React.useState(!!pageContext.password)

  let className = pageContext.pageType
  if (pageContext.isHomePage) {
    className += " home"
  }

  /**
   * Yup translations
   */
  React.useEffect(() => {
    Yup.setLocale({
      mixed: {
        required: t("form.required"),
      },
    })
  })

  React.useEffect(() => {
    dispatch({ type: "LOAD" })
  }, [dispatch])

  React.useEffect(() => {
    if (user.token && !user.first_name) {
      getProfile()
        .then(response => {
          const { email, username, avatar_url } = response.data.data
          dispatch({ type: "UPDATE_PROFILE", email, username, avatar_url })
        })
        .catch(() => {
          //dispatch({ type: "LOGOUT" })
          //navigate("/")
        })
    }
  }, [dispatch, user.token, user.first_name])

  React.useEffect(() => {
    if (
      pageContext.password &&
      sessionStorage.getItem("protection_" + pageContext.id)
    ) {
      setIsProtected(false)
    }
  }, [pageContext.password, pageContext.id])

  /**
   * Page is password protected. This is a simple protection that hides the page content.
   * This is not a security feature.
   */
  if (isProtected) {
    return (
      <PasswordProtection
        onSubmit={password => {
          if (password === pageContext.password) {
            setIsProtected(false)
            sessionStorage.setItem("protection_" + pageContext.id, "solved")
          } else {
            toast.error(t("protection.wrongpassword"), {
              toastId: "wrongpassword",
            })
          }
        }}
      />
    )
  }

  return (
    <div className={className}>
      <Header {...{ pageContext }} forceNegative={headerNegative} />
      <main>{children}</main>
      <Footer />
      {theme.feature_cookie_banner && <CookieBanner />}
      <Popup location={location} />
    </div>
  )
}

export { Layout }
